module.exports = __webpack_public_path__ + "img/machineLearningNew.5fb4dcaa.png";